import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SkillScore } from '../socio-emotional-skills-test-results.models';
import { SocioEmotionalSkill } from '../../socio-emotional-skills-test/socio-emotional-skills-test.models';

@Component({
  selector: 'app-socio-emotional-skills-test-results-radar',
  templateUrl: './socio-emotional-skills-test-results-radar.component.html',
  styleUrls: ['./socio-emotional-skills-test-results-radar.component.scss']
})
export class SocioEmotionalSkillsTestResultsRadarComponent implements OnChanges {
  @Input() skills: SocioEmotionalSkill[] = [];
  @Input() skillScores: SkillScore[] = [];

  chartOptions: any = {};
  isReady = false;

  private colorPalette: string[] = [
    '#3B61DD',
    '#86388F',
    '#E3B458',
    '#5C9B9B',
    '#DE748F',
    '#FFD700',
    '#47c97f'
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.skills || changes.skillScores) {
      this.buildChart();
    }
  }

  private buildChart(): void {
    if (!this.skills.length || !this.skillScores.length) return;

    const tooltipDescriptions: Map<string, string> = new Map<string, string>();
  
    const categories = this.skills.map((skill) => {
      const scoreEntry = this.skillScores.find(s => s.skill._id === skill._id);
      const score = scoreEntry?.average ?? 0;
      const level = skill.levels.find(level => score >= level.minScore && score <= level.maxScore);
      tooltipDescriptions.set(skill.name.trim(), level?.description ?? 'Sin descripción');
    
      return `${skill.name} - ${score.toFixed(1)}% ${level?.name ?? ''}`;
    });


    const data = this.skills.map(skill => {
      const entry = this.skillScores.find(s => s.skill._id === skill._id);
      return entry?.average ?? 0;
    });

    this.chartOptions = {
      chart: {
        height: 500,
        width: 1350,
        type: 'radar',
        toolbar: {
          show: false
        }
      },
      series: [
        {
          name: 'Resultado',
          data,
          color: 'rgba(255, 255, 255, 0.5)'
        }
      ],
      plotOptions: {
        radar: {
          size: 150,
          polygons: {
            strokeColors: '#969FFB',
            fill: {
              colors: ['#d7dbff']
            },
            connectorColors: this.colorPalette
          }
        }
      },
      xaxis: {
        categories,
        labels: {
          style: {
            colors: this.colorPalette,
            fontSize: '14px',
            fontFamily: '"Montserrat", sans-serif',
            fontWeight: 600,
          },
          trim:false,
          formatter: val => val.replace(/<br>/g, '\n')
        }
      },
      yaxis: {
        show: false,
        min: 0,
        max: 100
      },
      tooltip: {
        enabled: true,
        custom: ({ series, seriesIndex, dataPointIndex, w }) => {
          const skillLabel = w.globals.labels[dataPointIndex];
          const skillName = skillLabel.split('-')[0]; 

          console.log(tooltipDescriptions);
          console.log(skillName);


          const description = tooltipDescriptions.get(skillName.trim());
          const value = series[seriesIndex][dataPointIndex];
      
          return `
          <div style="
            padding: 10px;
            font-size: 13px;
            max-width: 250px;
            white-space: normal;
            word-wrap: break-word;
            color: #fff;
            background: #333;
            border-radius: 6px;
          ">
            <strong>Puntaje:</strong> ${value.toFixed(1)}%<br/>
            <strong>Descripción:</strong><br/> ${description}
          </div>
        `;
        }
      },
      legend: {
        show: false
      }
    };

    this.isReady = true;
  }


}
